// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import {appRouter} from './router/router';
import store from './store'

import './assets/icons' // icon

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'video.js/dist/video-js.css'
import VueVideoPlayer from 'vue-video-player'
import 'videojs-contrib-hls'
Vue.use(VueVideoPlayer)
Vue.use(ElementUI);
import iView from 'iview';
Vue.use(iView)
import echarts from 'echarts'
Vue.use(echarts)
// 引入全局uView
import cuView from './cuview-ui'
Vue.use(cuView)
import {
  Tree, Button, Tooltip, Radio, Avatar, Modal, RadioGroup, Table, locale,Poptip,
  Card, Form, FormItem, Icon, Input, MenuItem, Submenu,DatePicker,TimePicker,Divider,
  Col, MenuGroup, Menu, DropdownMenu, Dropdown, DropdownItem, Page,Upload,Select,Option,Notice,Drawer,
  Row, Badge, Tag, Breadcrumb, Message, BreadcrumbItem, Scroll, Spin,InputNumber,Cascader,LoadingBar
} from 'iview';



/*
import iView from 'iview';
Vue.use(iView)
*/

import 'iview/dist/styles/iview.css';
import mixin from './mixin'

require('./plugins');
import MyPlugin from  './plugins/plugin.js'

Vue.use(MyPlugin);

import VueParticles from 'vue-particles'
Vue.use(VueParticles)

// import VueI18n from 'vue-i18n';
// import en from 'iview/dist/locale/en-US';
// import zh from 'iview/dist/locale/zh-CN';

/*Vue.use(VueI18n);
const messages = {
  en: Object.assign({ message: 'hello' }, en),
  zh: Object.assign({ message: '你好' }, zh)
};

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'en',  // set locale
  messages  // set locale messages
});*/

Vue.component('Button', Button);
Vue.component('Tooltip', Tooltip);
Vue.component('Table', Table);
Vue.component('Card', Card);
Vue.component('Spin', Spin);
Vue.component('Form', Form);
Vue.component('Page', Page);
Vue.component('FormItem', FormItem);
Vue.component('Icon', Icon);
Vue.component('Input', Input);
Vue.component('Scroll', Scroll);
Vue.component('Menu', Menu);
Vue.component('MenuGroup', MenuGroup);
Vue.component('MenuItem', MenuItem);
Vue.component('Submenu', Submenu);
Vue.component('Col', Col);
Vue.component('RadioGroup', RadioGroup);
Vue.component('Radio', Radio);
Vue.component('DropdownMenu', DropdownMenu);
Vue.component('Dropdown', Dropdown);
Vue.component('DropdownItem', DropdownItem);
Vue.component('Row', Row);
Vue.component('Breadcrumb', Breadcrumb);
Vue.component('BreadcrumbItem', BreadcrumbItem);
Vue.component('DatePicker', DatePicker);
Vue.component('InputNumber', InputNumber);
Vue.component('TimePicker', TimePicker);
Vue.component('Badge', Badge);
Vue.component('Tag', Tag);
Vue.component('Avatar', Avatar);
Vue.component('Modal', Modal);
Vue.component('Upload', Upload);
Vue.component('Select', Select);
Vue.component('Option', Option);
Vue.component('Poptip', Poptip);
Vue.component('Cascader', Cascader);
Vue.component('Notice', Notice);
Vue.component('Drawer', Drawer);
Vue.component('Divider', Divider);

import CPage from '@/components/page/page.vue'

Vue.prototype.$Message = Message;
Vue.prototype.$Spin = Spin;
Vue.prototype.$Notice = Notice;


Vue.component('CPage', CPage);
Vue.config.productionTip = false;


Vue.mixin(mixin.global);
/* eslint-disable no-new */
new Vue({
  el: '#main', router, store,
  components: {App},
  template: '<App/>',
  created() {
    let tagsList = [];
    appRouter.map((item) => {
      if (item.children.length <= 1) {
        tagsList.push(item.children[0]);
      } else {
        tagsList.push(...item.children);
      }
    });
    this.$store.commit('setTagsList', tagsList);
  }
});


// 限制字节数量
// 商家模块 -> 商家列表 添加 缺 线上线下分成(编辑)



// WEBPACK FOOTER //
// ./src/main.js